/**
 * ./src/modules/product/hooks/useCarouselCurrent.ts
 *
 * Hook to control the current position of the carousel
 *
 * @copyright DesignShop, 2024
 * @since 12/17/2024
 */
import { useEffect, useState } from 'react';

import { CarouselApi } from '@/modules/common/components/carousel';

export function useCarouselCurrent(api?: CarouselApi) {
  const [current, setCurrent] = useState(0);

  useEffect(() => {
    if (!api) {
      return;
    }

    // Set initial position
    setCurrent(api.selectedScrollSnap());

    const handleSelect = () => {
      setCurrent(api.selectedScrollSnap());
    };

    api.on('select', handleSelect);

    return () => {
      api.off('select', handleSelect);
    };
  }, [api]);

  return current;
}
